import React from 'react'
import { ConfigProvider } from 'antd'
import { themeConfig } from '@/layout/theme'
import { IntlProvider } from 'react-intl'
import { useI18nStore, initLocaleData } from './i18n-store'

const I18nProvider: React.FC = props => {
  const { currentLang, antdLocale, i18nLocale } = useI18nStore()

  React.useEffect(() => {
    initLocaleData()
  }, [])

  if (!currentLang) {
    return null
  }

  return (
    <ConfigProvider locale={antdLocale} theme={themeConfig}>
      <IntlProvider locale={currentLang} messages={i18nLocale as any}>
        {props.children}
      </IntlProvider>
    </ConfigProvider>
  )
}

export default I18nProvider
